// [LAG-TRACE] file-parse marker — proves product.js.liquid loaded and parsed.
// Diagnostic only; behaviour-neutral. Remove once first-load is stable.
try {
  if (window.console && console.info) console.info('[LAG-TRACE] product.js.liquid: file parsed at top-level');
  window.__lagTrace = window.__lagTrace || [];
  window.__lagTrace.push({ at: 'file-parse', t: Date.now() });
} catch (_) {}

// [LAG-TRACE] global error capture — any uncaught error inside this file
// (or anywhere on the page) is recorded so the diagnostic snapshot can show
// what threw without us having to scroll vendor noise.
try {
  window.addEventListener('error', function (e) {
    try {
      (window.__lagTrace = window.__lagTrace || []).push({
        at: 'window-error',
        t: Date.now(),
        msg: (e && e.message) || '',
        src: (e && e.filename) || '',
        line: (e && e.lineno) || 0
      });
    } catch (_) {}
  });
} catch (_) {}

// Run fn on DOMContentLoaded, OR immediately if DCL has already fired.
// OneTrust (and similar consent SDKs) can re-inject scripts after DCL,
// in which case a plain addEventListener('DOMContentLoaded', …) never fires.
function lagOnReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
}

// Function to update CSS custom property for main image height
function updateMainImageHeight() {
  const mainImage = document.querySelector('.main-slider .swiper-slide-active img') ||
                    document.querySelector('.main-slider img.max-w-\\[100vw\\].w-full') ||
                    document.querySelector('.main-slider img');
  
  if (mainImage && mainImage.offsetHeight > 0) {
    const mainSlider = document.querySelector('.product-main__media-slider');
    if (mainSlider) {
      mainSlider.style.setProperty('--main-image-height', mainImage.offsetHeight + 'px');
    }
  }
}

// Function to directly set thumbnail bar height to match main image height
// Enhanced with multiple fallback mechanisms for cross-browser reliability
function syncThumbnailBarHeight() {
  // Get the main slider container for accurate height measurement
  const mainSlider = document.querySelector('.main-slider');
  const mainSliderWrapper = document.getElementById('main-slider-wrapper');
  
  // Try multiple selectors to find the active/visible main image
  const activeMainImage = document.querySelector('.main-slider .swiper-slide-active img') ||
                          document.querySelector('.main-slider .swiper-slide:not([style*="display: none"]) img') ||
                          document.querySelector('.main-slider img.max-w-\\[100vw\\].w-full') ||
                          document.querySelector('.swiper-slide img') ||
                          document.querySelector('.main-slider img');

  // Get thumbnail bar elements
  const thumbnailBarContainer = document.querySelector('.thumbnail-bar-container');
  const thumbnailBar = document.querySelector('.product-thumbnail-bar');

  // Calculate the target height from multiple sources for reliability
  let targetHeight = 0;
  
  // Priority 1: Use main slider container height if available
  if (mainSlider && mainSlider.offsetHeight > 0) {
    targetHeight = mainSlider.offsetHeight;
  }
  
  // Priority 2: Use main slider wrapper height
  if (targetHeight === 0 && mainSliderWrapper && mainSliderWrapper.offsetHeight > 0) {
    targetHeight = mainSliderWrapper.offsetHeight;
  }
  
  // Priority 3: Use active main image height
  if (targetHeight === 0 && activeMainImage && activeMainImage.offsetHeight > 0) {
    targetHeight = activeMainImage.offsetHeight;
  }
  
  // Priority 4: Use computed height of main slider
  if (targetHeight === 0 && mainSlider) {
    const computedStyle = window.getComputedStyle(mainSlider);
    const computedHeight = parseFloat(computedStyle.height);
    if (computedHeight > 0 && !isNaN(computedHeight)) {
      targetHeight = computedHeight;
    }
  }

  // Apply the height if we found a valid target
  if (targetHeight > 0) {
    // Apply to thumbnail bar container with both height and max-height for reliability
    if (thumbnailBarContainer) {
      thumbnailBarContainer.style.maxHeight = targetHeight + 'px';
      thumbnailBarContainer.style.height = targetHeight + 'px';
    }

    if (thumbnailBar) {
      thumbnailBar.style.maxHeight = targetHeight + 'px';
      thumbnailBar.style.height = targetHeight + 'px';
      // Add class to show the thumbnail bar now that height is set
      thumbnailBar.classList.add('height-set');
    }
    
    // Store successful height for verification
    window._lastThumbnailBarHeight = targetHeight;
    return true;
  }
  
  return false; // Height sync failed, caller should retry
}

// Single consolidated height-sync system: ResizeObserver on the main slider
// + per-image load handler. Replaces the prior triple-mechanism (separate
// ResizeObserver + MutationObserver + setInterval-3000ms-forever + 5 staggered
// setTimeouts) which competed on the same DOM and could fire storms on
// Swiper class transitions.
let thumbnailHeightObserver = null;

function initThumbnailHeightTracking() {
  const mainSlider = document.querySelector('.main-slider');
  if (!mainSlider) return;

  // Sync now in case the image is already laid out.
  syncThumbnailBarHeight();
  syncMobileThumbnailBarHeight();

  // ResizeObserver covers: image decode-driven height changes, viewport
  // resize, Swiper layout passes. Debounced so rapid Swiper class flips
  // don't cause sync storms.
  if (typeof ResizeObserver !== 'undefined') {
    if (thumbnailHeightObserver) thumbnailHeightObserver.disconnect();
    let pending = null;
    thumbnailHeightObserver = new ResizeObserver(() => {
      clearTimeout(pending);
      pending = setTimeout(() => {
        syncThumbnailBarHeight();
        syncMobileThumbnailBarHeight();
      }, 50);
    });
    thumbnailHeightObserver.observe(mainSlider);
  }

  // One-shot per-image load fallback for browsers that don't fire
  // ResizeObserver on initial image decode (rare but defensive).
  document.querySelectorAll('.main-slider img').forEach((img) => {
    if (img.complete) return;
    img.addEventListener('load', () => {
      syncThumbnailBarHeight();
      syncMobileThumbnailBarHeight();
    }, { once: true });
  });
}

// Function to sync mobile thumbnail bar height
function syncMobileThumbnailBarHeight() {
  if (!document.getElementById('product-thumbnail-bar-mobile')) return;

  const activeMainImage = document.querySelector('.main-slider .swiper-slide-active img') ||
                          document.querySelector('.main-slider img.max-w-\\[100vw\\].w-full') ||
                          document.querySelector('.swiper-slide img') ||
                          document.querySelector('.main-slider img');

  const productThumbnailBarMobile = document.getElementById('product-thumbnail-bar-mobile');

  if (activeMainImage && activeMainImage.offsetHeight > 0) {
    // Show the mobile thumbnail bar by adding height-set class
    productThumbnailBarMobile.classList.add('height-set');
  }
}

// Utility function for debouncing - defined globally
function debounceGlobal(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Global variable for thumbnail bar positioning - accessible throughout the script
let thumbnails_bar_on_bottom = true;



try { (window.__lagTrace = window.__lagTrace || []).push({ at: 'pre-resize-listeners', t: Date.now() }); } catch (_) {}
// Add window resize listener for syncing thumbnail bar height
window.addEventListener('resize', debounceGlobal(syncThumbnailBarHeight, 100));

// Add window resize listener for syncing mobile thumbnail bar height
window.addEventListener('resize', debounceGlobal(syncMobileThumbnailBarHeight, 100));
try { (window.__lagTrace = window.__lagTrace || []).push({ at: 'post-resize-listeners', t: Date.now() }); } catch (_) {}

// Update height when images load
window.addEventListener('load', syncThumbnailBarHeight);
window.addEventListener('load', syncMobileThumbnailBarHeight);
try { (window.__lagTrace = window.__lagTrace || []).push({ at: 'post-load-listeners', t: Date.now() }); } catch (_) {}

// Init thumbnail height tracking on DOMContentLoaded.
lagOnReady(() => {
  try { (window.__lagTrace = window.__lagTrace || []).push({ at: 'thumb-height-dcl-fire', t: Date.now() }); } catch (_) {}
  try {
    initThumbnailHeightTracking();
  } catch (err) {
    if (window.console && console.error) console.error('[LAG-PDP-DCL-1]', err);
  }
});

lagOnReady(() => {
  try { (window.__lagTrace = window.__lagTrace || []).push({ at: 'master-dcl-fire', t: Date.now() }); } catch (_) {}
  try {
    window.__lagInit_productMain = true;
  // Configuration: Set to true to display thumbnail bar at bottom, false for left side (desktop)
  // Mobile will always display thumbnails at bottom regardless of this setting
  thumbnails_bar_on_bottom = true; // Update global variable

  // Select all necessary DOM elements
  const productForm = document.querySelector('form[action="/cart/add"]');
  const variantSelector = document.getElementById('swatch-icons');
  const priceElement = document.querySelector('.price_section span[itemprop="price"]');
  const addToCartButton = document.querySelector('.product-form__submit');
  const quantityInput = document.querySelector('.quantity-input');
  const quantitySelector = document.querySelector('.quantity-selector');
  const customDropdown = document.querySelector('.custom-dropdown');
  const dropdownMenu = customDropdown ? customDropdown.querySelector('.variant-dropdown-menu') : null;
  const skuElement = document.querySelector('.variant-sku');

  let mainSwiper;
  let isManuallyChanging = false;
  
  // Thumbnail slider elements
  const thumbnailBarContainer = document.getElementById('thumbnail-bar-container');
  const productContainer = document.querySelector('.product-container');
  
  // Apply thumbnail bar positioning based on configuration
  function applyThumbnailBarLayout() {
    const productContainer = document.querySelector('.product-container');
    const thumbnailBar = document.querySelector('.product-thumbnail-bar');
    const mainSlider = document.querySelector('.product-main__media-slider');
    const isMobile = window.innerWidth < 1024; // lg breakpoint

    if (!productContainer || !thumbnailBar) return;

    // Always show thumbnails at bottom on mobile, or when thumbnails_bar_on_bottom is true on desktop
    if (isMobile || thumbnails_bar_on_bottom) {
      // Bottom layout
      productContainer.style.flexDirection = 'column';
      productContainer.style.alignItems = 'stretch';

      // Reset thumbnail bar styles for horizontal layout
      thumbnailBar.style.width = 'auto';
      thumbnailBar.style.flexShrink = '0';
      thumbnailBar.style.order = '2'; // Place after main image
      thumbnailBar.style.maxHeight = 'none';

      // Update thumbnail bar container for horizontal scrolling
      if (thumbnailBarContainer) {
        thumbnailBarContainer.style.display = 'flex';
        thumbnailBarContainer.style.flexDirection = 'row';
        thumbnailBarContainer.style.overflowX = 'auto';
        thumbnailBarContainer.style.overflowY = 'hidden';
        thumbnailBarContainer.style.gap = '1rem';
        thumbnailBarContainer.style.paddingBottom = '0.5rem';
      }

      // Update individual thumbnail items for horizontal layout
      document.querySelectorAll('.thumbnail-item').forEach(item => {
        item.style.width = '80px';
        item.style.height = '80px';
        item.style.marginBottom = '0';
        item.style.flexShrink = '0';
      });

      // Remove last item margin
      const lastThumbnail = document.querySelector('.thumbnail-item:last-child');
      if (lastThumbnail) {
        lastThumbnail.style.marginRight = '0';
      }

    } else {
      // Left side layout (default desktop)
      productContainer.style.flexDirection = 'row';
      productContainer.style.alignItems = 'flex-start';

      // Reset thumbnail bar styles for vertical layout
      thumbnailBar.style.width = '80px';
      thumbnailBar.style.flexShrink = '0';
      thumbnailBar.style.order = '1'; // Place before main image
      thumbnailBar.style.marginTop = '0';
      thumbnailBar.style.marginRight = '1rem'; // Gap between thumbnails and main image

      // Update thumbnail bar container for vertical scrolling
      if (thumbnailBarContainer) {
        thumbnailBarContainer.style.display = 'flex';
        thumbnailBarContainer.style.flexDirection = 'column';
        thumbnailBarContainer.style.overflowX = 'hidden';
        thumbnailBarContainer.style.overflowY = 'auto';
        thumbnailBarContainer.style.gap = '0';
        thumbnailBarContainer.style.paddingBottom = '0';
      }

      // Update individual thumbnail items for vertical layout
      document.querySelectorAll('.thumbnail-item').forEach(item => {
        item.style.width = '80px';
        item.style.height = '80px';
        item.style.marginRight = '0';
        item.style.flexShrink = '0';
      });

      // Remove last item margin
      const lastThumbnail = document.querySelector('.thumbnail-item:last-child');
      if (lastThumbnail) {
        lastThumbnail.style.marginBottom = '0';
      }

      // Set main slider order
      if (mainSlider) {
        mainSlider.style.order = '2';
      }
    }
  }

  // Debug thumbnail container detection
  // console.log('🔍 === THUMBNAIL CONTAINER DETECTION ===');
  // console.log(`thumbnailBarContainer (by ID): ${thumbnailBarContainer ? '✅ Found' : '❌ Not found'}`);
  // console.log(`thumbnailBarContainer (by class): ${document.querySelector('.thumbnail-bar-container') ? '✅ Found' : '❌ Not found'}`);
  // console.log(`All thumbnail items: ${document.querySelectorAll('.thumbnail-item').length}`);
  // console.log(`All elements with 'thumbnail' in class:`, document.querySelectorAll('[class*="thumbnail"]'));
  // console.log('==========================================');
  
  // Utility function for debouncing
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Initialize Swiper sliders for main product images

  function initializeSwiper() {
  try { (window.__lagTrace = window.__lagTrace || []).push({ at: 'initializeSwiper-enter', t: Date.now(), swiperGlobal: typeof window.Swiper, sliderInDom: !!document.querySelector('.main-slider') }); } catch (_) {}
  try {
    mainSwiper = new Swiper('.main-slider', {
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      allowTouchMove: true,
        touchRatio: 1,
        threshold: 5,
        grabCursor: true,
    });
  } catch (err) {
    console.warn('[product] main-slider Swiper init error', err);
  }



  // Add keyboard navigation support
  document.addEventListener('keydown', function(event) {
    if (event.target.closest('.product-main')) {
      switch(event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          if (mainSwiper) {
            mainSwiper.slidePrev();
          }
          break;
        case 'ArrowRight':
          event.preventDefault();
          if (mainSwiper) {
            mainSwiper.slideNext();
          }
          break;
        case 'Home':
          event.preventDefault();
          if (mainSwiper) {
            mainSwiper.slideTo(0);
          }
          break;
        case 'End':
          event.preventDefault();
          if (mainSwiper) {
            mainSwiper.slideTo(mainSwiper.slides.length - 1);
          }
          break;
      }
    }
  });

  // Apply initial thumbnail bar layout
  applyThumbnailBarLayout();

  // Initialize thumbnail functionality
  addSwiperEventListeners();
  initializeThumbnailClickHandlers();

  // Initialize mobile thumbnail functionality
  initializeMobileThumbnailClickHandlers();

  // Initialize thumbnail drag scroll functionality
  initializeThumbnailDragScroll();
  
  
  // Update height on image load and slide change
  const mainImages = document.querySelectorAll('.main-slider img');
  mainImages.forEach(img => {
    if (img.complete) {
      updateMainImageHeight();
    } else {
      img.addEventListener('load', updateMainImageHeight);
    }
  });
  
  // Update on window resize
  window.addEventListener('resize', debounce(() => {
    updateMainImageHeight();
    applyThumbnailBarLayout();
  }, 100));

  // Safety net for products without variants (or any path where the
  // variant-change chain doesn't fire). The .filter-complete class is
  // normally added by updateSliderImages -> filterThumbnailImages on
  // variant change; for no-variant products, no change ever fires and
  // the bar stays hidden by CSS (.product-thumbnail-bar.height-set.filter-complete
  // gates opacity/visibility). Adding it here unconditionally — idempotent
  // for variant products. Pair with mainSwiper.update() so the height
  // observer recomputes against the now-laid-out slide, which adds
  // .height-set the moment image dimensions are known.
  setTimeout(function () {
    if (mainSwiper) {
      try { mainSwiper.update(); } catch (_) {}
    }
    if (typeof syncThumbnailBarHeight === 'function') syncThumbnailBarHeight();
    var tBar = document.querySelector('.product-thumbnail-bar');
    if (tBar) tBar.classList.add('filter-complete');
    var tBarMobile = document.getElementById('product-thumbnail-bar-mobile');
    if (tBarMobile) tBarMobile.classList.add('filter-complete');
  }, 100);
}

// Performance optimization: Cache DOM queries and computed values
// ===== IMAGE FILTERING CONFIGURATION =====
// Easy to customize settings for the image filtering system
const FILTER_CONFIG = {
    // Expected minimum variant images before triggering fallback
    minVariantImages: 3,
    minThumbnailVariants: 2,
    
    // General keywords that should be shown for all variants.
    // Also double as the deprioritize list: variant-specific files whose
    // filename contains any of these still show only for their owning
    // variant, but render after (order '2') plain variant images.
    generalKeywords: [
        'share', 'shared', 'common', 'video','general', 'lifestyle', 'lifestyles', 'videos', 'public', 'main',
        'infographics', 'model', 'logo', 'display', 'stories', 'gifs', 'product_announcements'
    ],

    // Patterns that should exclude images from being treated as general
    excludedPatterns: ['PROD_ALTIMG', 'TEMP', 'DRAFT', 'BACKUP'],
    
    // SKU pattern detection settings
    skuPatterns: {
        basic: /[A-Z]+\d+/g,                    // Basic SKU pattern
        enhanced: /[A-Z]+\d+[A-Z0-9_-]*/g,     // Enhanced pattern with extensions
        flexible: /[_\-\s\.]/g,                  // Flexible separator handling
        skuSuffix: /[A-Za-z]+$/                  // Trailing letter suffix (e.g. N in CP630N)
    }
};

// Performance optimization: Pre-compile regex patterns
const SKU_PATTERN_REGEX = FILTER_CONFIG.skuPatterns.basic;
const PROD_ALTIMG_REGEX = /PROD_ALTIMG/i;

// Enhanced performance optimization: More flexible regex patterns (case-insensitive)
const ENHANCED_SKU_REGEX = /[A-Za-z]+\d+[A-Za-z0-9_-]*/gi;
const FLEXIBLE_SEPARATOR_REGEX = FILTER_CONFIG.skuPatterns.flexible;

// Performance optimization: Pre-compute uppercase keywords
const GENERAL_IMAGE_KEYWORDS = FILTER_CONFIG.generalKeywords.map(keyword => keyword.toUpperCase());

// Configurable exclusion patterns (can be customized later)
const EXCLUDED_PATTERNS = FILTER_CONFIG.excludedPatterns;
const EXCLUDED_PATTERNS_REGEX = new RegExp(EXCLUDED_PATTERNS.join('|'), 'i');

function getBaseSku(variantSku) {
    const baseSkuMatch = variantSku.match(/^([A-Za-z]+\d+)(?=[A-Za-z]+$)/);
    return baseSkuMatch ? baseSkuMatch[1] : null;
}

function hasBaseSkuPrefix(fileName, baseSku) {
    if (!baseSku || !fileName.startsWith(baseSku)) return false;
    const charAfter = fileName[baseSku.length];
    return !charAfter || /[_\-\.\s]/.test(charAfter);
}

function extractSkuCandidates(fileName) {
    const skuMatches = fileName.match(ENHANCED_SKU_REGEX) || [];
    const candidates = new Set();

    skuMatches.forEach((match) => {
        const skuParts = match.match(/[A-Za-z]+\d+/gi) || [];
        skuParts.forEach((skuPart) => candidates.add(skuPart.toUpperCase()));
    });

    return Array.from(candidates);
}

function isGeneralImageName(fileName) {
    if (EXCLUDED_PATTERNS_REGEX.test(fileName)) return false;

    const normalizedName = fileName.replace(FLEXIBLE_SEPARATOR_REGEX, '');
    return GENERAL_IMAGE_KEYWORDS.some((keyword) => normalizedName.includes(keyword));
}

// SKU ownership wins over generic keywords. Any filename that contains a SKU
// belongs only to that SKU's variant; generic image keywords apply only when no SKU exists.
function classifyImageName(rawName, variantSku) {
    const fileName = (rawName || '').toUpperCase();
    const normalizedSku = (variantSku || '').toUpperCase().trim();
    const baseSku = getBaseSku(normalizedSku);

    if (!fileName) {
        return { show: false, type: 'hidden', order: null };
    }

    // Products without variants (or variants with no SKU) have nothing to
    // filter against. Show every image rather than hiding any filename that
    // happens to contain SKU-shaped tokens — without this guard, no-variant
    // products end up with every slide classified 'other-variant' and the
    // main slider/thumbnail bar render empty until a (never-fired) variant
    // change resets things.
    if (!normalizedSku) {
        return { show: true, type: 'general', order: isGeneralImageName(fileName) ? '2' : '1' };
    }

    // Variant images whose name contains any general keyword still show
    // only for their owning variant, but render after (order '2') plain
    // variant images — the general-keyword test doubles as a deprioritize
    // signal. e.g. CP630_LIFESTYLE_01 and CP630_COMMON_03 both render late.
    const variantOrder = isGeneralImageName(fileName) ? '2' : '1';

    if (fileName.startsWith(normalizedSku) || hasBaseSkuPrefix(fileName, baseSku)) {
        return { show: true, type: 'variant', order: variantOrder };
    }

    const skuCandidates = extractSkuCandidates(fileName);
    const containsCurrentSku = skuCandidates.some((candidate) => candidate === normalizedSku || (baseSku && candidate === baseSku));

    if (containsCurrentSku) {
        return { show: true, type: 'variant', order: variantOrder };
    }

    if (skuCandidates.length > 0) {
        return { show: false, type: 'other-variant', order: null };
    }

    if (isGeneralImageName(fileName)) {
        return { show: true, type: 'general', order: '2' };
    }

    return { show: false, type: 'hidden', order: null };
}

// Apply display change to a slide / thumbnail. The 'filtered-out' class
// gates animations and is read by sibling code; keep adding/removing it.
function applyDisplayChange(element, displayValue, visibility, isFiltered) {
    if (!element) return;
    element.style.display = displayValue;
    element.style.visibility = visibility;
    if (isFiltered) {
        element.classList.add('filtered-out');
    } else {
        element.classList.remove('filtered-out');
    }
}



function updateSliderImages(selectedVariant) {
    const variantSku = (selectedVariant.sku || '').toUpperCase().trim();
    const baseSku = getBaseSku(variantSku);

    const allSlides = Array.from(document.querySelectorAll('.main-slider .swiper-slide'));

    let visibleProductImages = 0;
    let visibleGeneralImages = 0;

    for (let index = 0; index < allSlides.length; index++) {
        const slide = allSlides[index];
        const decision = classifyImageName(slide.dataset.name, variantSku);

        if (decision.show) {
            applyDisplayChange(slide, 'block', 'visible', false);
            slide.style.order = decision.order;

            if (decision.type === 'variant') {
                visibleProductImages++;
            } else if (decision.type === 'general') {
                visibleGeneralImages++;
            }
        } else {
            applyDisplayChange(slide, 'none', 'hidden', true);
        }
    }
    
    const totalVisibleImages = visibleProductImages + visibleGeneralImages;
    
    // Enhanced fallback logic: Trigger if variant image count is too low
    let fallbackVariantImages = 0;
    const expectedVariantImages = Math.min(FILTER_CONFIG.minVariantImages, allSlides.length); // Use config value
    
    if (visibleProductImages < expectedVariantImages && allSlides.length > 0) {
        // console.log('🚨 === ENHANCED FALLBACK FILTER ===');
        // console.log(`⚠️ Only ${visibleProductImages} variant images found, expected at least ${expectedVariantImages}, applying enhanced fallback search...`);
        
        allSlides.forEach((slide, index) => {
            const slideName = (slide.dataset.name || '').toUpperCase();
            const originalSlideName = slide.dataset.name || 'NO_NAME';
            
            // Skip already visible images
            if (slide.style.display === 'block') return;
            
            // Enhanced fallback: Check if image filename contains the target variant SKU anywhere (case-insensitive)
            const containsSku = slideName.includes(variantSku.toUpperCase()) ||
                              (baseSku && slideName.includes(baseSku)) ||
                              slideName.includes(variantSku.toLowerCase()) ||
                              slideName.toUpperCase().includes(variantSku.toUpperCase());
            
            // console.log(`🔍 Enhanced fallback check for "${originalSlideName}": ${containsSku ? '✅ CONTAINS SKU' : '❌ NO SKU'}`);
            
            if (containsSku) {
                // Firefox fix: Use explicit function to ensure style changes are applied
                applyDisplayChange(slide, 'block', 'visible', false);
                slide.style.order = isGeneralImageName(slideName) ? '2' : '1';
                fallbackVariantImages++;
                // console.log(`   → RESULT: ✅ SHOW (Enhanced Fallback Variant Image)`);
            }
        });

        // console.log(`🔄 Enhanced fallback found ${fallbackVariantImages} additional variant images`);
        // console.log('==========================================');
        // console.log('');
    }
    
    const finalTotalVisibleImages = totalVisibleImages + fallbackVariantImages;


    // Hide/show navigation buttons based on image count
    const nextButton = document.querySelector('.swiper-button-next');
    const prevButton = document.querySelector('.swiper-button-prev');
    
    if (finalTotalVisibleImages <= 1) {
        if (nextButton) {
            nextButton.style.display = 'none';
            nextButton.style.visibility = 'hidden';
            nextButton.style.pointerEvents = 'none';
            nextButton.classList.add('swiper-button-disabled', 'swiper-button-lock');
        }
        if (prevButton) {
            prevButton.style.display = 'none';
            prevButton.style.visibility = 'hidden';
            prevButton.style.pointerEvents = 'none';
            prevButton.classList.add('swiper-button-disabled', 'swiper-button-lock');
        }
        /* filter debug removed */
    } else {
        if (nextButton) {
            nextButton.style.display = '';
            nextButton.style.visibility = '';
            nextButton.style.pointerEvents = '';
            nextButton.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        }
        if (prevButton) {
            prevButton.style.display = '';
            prevButton.style.visibility = '';
            prevButton.style.pointerEvents = '';
            prevButton.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        }
        /* filter debug removed */
    }
    
    // Update thumbnail slider with direct filtering
    updateThumbnailSlider(allSlides, finalTotalVisibleImages, selectedVariant);

    // Update mobile thumbnail slider with direct filtering
    filterMobileThumbnailImages(selectedVariant);

    // Update Swiper to reflect the changes - with retry mechanism
    setTimeout(() => {
        if (mainSwiper) {
            mainSwiper.update();
            mainSwiper.slideTo(0, 0);
            /* filter debug removed */
        } else {
            /* filter debug removed */
            // If swiper isn't ready yet, try again
            setTimeout(() => {
                if (mainSwiper) {
                    mainSwiper.update();
                    mainSwiper.slideTo(0, 0);
                    /* filter debug removed */
                }
            }, 100);
        }
    }, 50);

    // Ensure filter-complete class is added as a final backup
    // This handles cases where the filtering functions return early
    const thumbnailBar = document.querySelector('.product-thumbnail-bar');
    if (thumbnailBar && !thumbnailBar.classList.contains('filter-complete')) {
        thumbnailBar.classList.add('filter-complete');
    }
    const productThumbnailBarMobile = document.getElementById('product-thumbnail-bar-mobile');
    if (productThumbnailBarMobile && !productThumbnailBarMobile.classList.contains('filter-complete')) {
        productThumbnailBarMobile.classList.add('filter-complete');
    }
    
}


// Apply the exact same filtering logic to thumbnails as main slider
function filterThumbnailImages(selectedVariant) {
    if (!thumbnailBarContainer) {
        const thumbnailBar = document.querySelector('.product-thumbnail-bar');
        if (thumbnailBar) thumbnailBar.classList.add('filter-complete');
        return 0;
    }

    const variantSku = (selectedVariant.sku || '').toUpperCase().trim();
    const baseSku = getBaseSku(variantSku);
    const thumbnailItems = thumbnailBarContainer.querySelectorAll('.thumbnail-item');

    let visibleThumbnailImages = 0;
    let visibleThumbnailGeneralImages = 0;

    for (let index = 0; index < thumbnailItems.length; index++) {
        const thumbnail = thumbnailItems[index];
        const decision = classifyImageName(thumbnail.dataset.name, variantSku);

        if (decision.show) {
            applyDisplayChange(thumbnail, 'block', 'visible', false);
            thumbnail.style.order = decision.order;

            if (decision.type === 'variant') {
                visibleThumbnailImages++;
            } else if (decision.type === 'general') {
                visibleThumbnailGeneralImages++;
            }
        } else {
            applyDisplayChange(thumbnail, 'none', 'hidden', true);
        }
    }
    
    const totalVisibleThumbnails = visibleThumbnailImages + visibleThumbnailGeneralImages;
    
    // Enhanced fallback logic: Trigger if thumbnail variant count is too low
    let fallbackThumbnailImages = 0;
    const expectedThumbnailVariants = Math.min(FILTER_CONFIG.minThumbnailVariants, thumbnailItems.length); // Use config value
    
    if (visibleThumbnailImages < expectedThumbnailVariants && thumbnailItems.length > 0) {
        // console.log('🚨 === ENHANCED FALLBACK FILTER (THUMBNAILS) ===');
        // console.log(`⚠️ Only ${visibleThumbnailImages} variant thumbnails found, expected at least ${expectedThumbnailVariants}, applying enhanced fallback search...`);
        
        thumbnailItems.forEach((thumbnail, index) => {
            const thumbName = (thumbnail.dataset.name || '').toUpperCase();
            const originalThumbName = thumbnail.dataset.name || 'NO_NAME';
            
            // Skip already visible thumbnails
            if (thumbnail.style.display === 'block') return;
            
            // Enhanced fallback: Check if thumbnail filename contains the target variant SKU anywhere (case-insensitive)
            const containsSku = thumbName.includes(variantSku.toUpperCase()) ||
                              (baseSku && thumbName.includes(baseSku)) ||
                              thumbName.includes(variantSku.toLowerCase()) ||
                              thumbName.toUpperCase().includes(variantSku.toUpperCase());
            
            // console.log(`🔍 Enhanced thumbnail fallback check for "${originalThumbName}": ${containsSku ? '✅ CONTAINS SKU' : '❌ NO SKU'}`);
            
            if (containsSku) {
                // Firefox fix: Use explicit function to ensure style changes are applied
                applyDisplayChange(thumbnail, 'block', 'visible', false);
                thumbnail.style.order = isGeneralImageName(thumbName) ? '2' : '1';
                fallbackThumbnailImages++;
                // console.log(`   → RESULT: ✅ SHOW (Enhanced Fallback Variant Thumbnail)`);
            }
        });
        
        // console.log(`🔄 Enhanced fallback found ${fallbackThumbnailImages} additional variant thumbnails`);
        // console.log('==========================================');
        // console.log('');
    }
    
    const finalTotalVisibleThumbnails = totalVisibleThumbnails + fallbackThumbnailImages;

    // Hide/show entire thumbnail bar based on image count
    if (finalTotalVisibleThumbnails <= 1) {
        if (productContainer) productContainer.classList.add('thumbnail-bar-single-image');
        /* filter debug removed */
    } else {
        if (productContainer) productContainer.classList.remove('thumbnail-bar-single-image');
        /* filter debug removed */
    }
    
    // Set visible index for each visible thumbnail in order
    let visibleIndex = 0;
    const visibleThumbnails = Array.from(thumbnailItems)
        .filter(thumb => thumb.style.display !== 'none')
        .sort((a, b) => {
            const orderA = parseInt(a.style.order) || 0;
            const orderB = parseInt(b.style.order) || 0;
            return orderA - orderB;
        });
    
    visibleThumbnails.forEach((thumbnail, index) => {
        thumbnail.setAttribute('data-visible-index', index);
    });
    
    // Detailed breakdown of visible thumbnails
    /* filter debug removed */
    
    // Set the first visible thumbnail as active
    setActiveThumbnail(0);

    // Mark filtering as complete - this allows the thumbnail bar to become visible
    const thumbnailBar = document.querySelector('.product-thumbnail-bar');
    if (thumbnailBar) {
        thumbnailBar.classList.add('filter-complete');
    }
    
    return finalTotalVisibleThumbnails;
}

// Thumbnail slider functions - mirrors main slider filtering exactly
function updateThumbnailSlider(mainSlides, totalVisibleImages, selectedVariant) {
    // console.log('🔄 === UPDATE THUMBNAIL SLIDER CALLED ===');
    // console.log(`📊 Main slides count: ${mainSlides.length}`);
    // console.log(`📊 Total visible images: ${totalVisibleImages}`);
    // console.log(`🎯 Selected variant: ${selectedVariant.sku}`);
    
    if (!thumbnailBarContainer) {
        // console.log('❌ thumbnailBarContainer not found!');
        return;
    }
    
    // console.log('✅ thumbnailBarContainer found, proceeding with filtering...');
    
    // Apply the same filtering logic as main slider to thumbnails directly
    const visibleThumbnailCount = filterThumbnailImages(selectedVariant);
    
    // console.log(`🔄 Thumbnail filtering complete, visible count: ${visibleThumbnailCount}`);
    
    return visibleThumbnailCount;
}



function setActiveThumbnail(activeIndex) {
    if (!thumbnailBarContainer) return;
    
    // Get all visible thumbnails in the correct order
    const visibleThumbnails = Array.from(thumbnailBarContainer.querySelectorAll('.thumbnail-item'))
        .filter(item => item.style.display !== 'none')
        .sort((a, b) => {
            const orderA = parseInt(a.style.order) || 0;
            const orderB = parseInt(b.style.order) || 0;
            return orderA - orderB;
        });
    
            /* filter debug removed */
    
    // Remove active class from all thumbnails
    visibleThumbnails.forEach(item => item.classList.remove('active'));
    
    // Add active class to the correct thumbnail
    if (visibleThumbnails[activeIndex]) {
        visibleThumbnails[activeIndex].classList.add('active');
        scrollThumbnailIntoView(visibleThumbnails[activeIndex]);
        /* filter debug removed */
    }
}

function scrollThumbnailIntoView(thumbnail) {
    if (!thumbnail || !thumbnailBarContainer) return;

    const container = thumbnailBarContainer;
    const containerRect = container.getBoundingClientRect();
    const thumbRect = thumbnail.getBoundingClientRect();

    // Detect layout by checking container's actual CSS flex direction
    const containerFlexDirection = window.getComputedStyle(container).flexDirection;
    const isHorizontalLayout = containerFlexDirection === 'row';

    const BUFFER = 8; // Pixel buffer for edge detection

    if (isHorizontalLayout) {
        // Horizontal scrolling (bottom thumbnail bar on mobile/tablet)
        const isLeft = thumbRect.left < containerRect.left + BUFFER;
        const isRight = thumbRect.right > containerRect.right - BUFFER;

        if (isLeft || isRight) {
            // Center the thumbnail horizontally in the container
            const target = thumbnail.offsetLeft - (container.clientWidth / 2 - thumbnail.clientWidth / 2);
            const clampedTarget = Math.max(0, Math.min(target, container.scrollWidth - container.clientWidth));
            container.scrollTo({ left: clampedTarget, behavior: 'smooth' });
        }
    } else {
        // Vertical scrolling (left sidebar thumbnail bar on desktop)
        const isAbove = thumbRect.top < containerRect.top + BUFFER;
        const isBelow = thumbRect.bottom > containerRect.bottom - BUFFER;

        if (isAbove || isBelow) {
            // Center the thumbnail vertically in the container
            const target = thumbnail.offsetTop - (container.clientHeight / 2 - thumbnail.clientHeight / 2);
            const clampedTarget = Math.max(0, Math.min(target, container.scrollHeight - container.clientHeight));
            container.scrollTo({ top: clampedTarget, behavior: 'smooth' });
        }
    }
}

function initializeThumbnailClickHandlers() {
    if (!thumbnailBarContainer) return;
    
    /* filter debug removed */
    
    // Click handler for thumbnail navigation
    thumbnailBarContainer.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        const clickedThumbnail = event.target.closest('.thumbnail-item');
        if (!clickedThumbnail || clickedThumbnail.style.display === 'none') return;
        
        // Get the visible index of the clicked thumbnail
        const visibleIndex = parseInt(clickedThumbnail.getAttribute('data-visible-index') || '0');
        const slideIndex = parseInt(clickedThumbnail.getAttribute('data-slide-index') || '0');
        
        /* filter debug removed */
        
        // Navigate to the corresponding slide in main swiper
        if (mainSwiper) {
            isManuallyChanging = true;
            
            // Try to navigate to the slide
            try {
                mainSwiper.slideTo(visibleIndex, 0); // No animation for instant response
                setActiveThumbnail(visibleIndex);
                /* filter debug removed */
            } catch (error) {
                /* filter debug removed */
            }
            
            setTimeout(() => {
                isManuallyChanging = false;
            }, 100);
        } else {
            /* filter debug removed */
        }
    });
    
    // Enhanced mouse wheel scrolling for thumbnail bar
    thumbnailBarContainer.addEventListener('wheel', (event) => {
        // Allow normal scrolling behavior
        // The CSS already handles this, but this ensures it works everywhere
        event.stopPropagation();
    });
    
    // Add pointer cursor to all thumbnail items
    const thumbnailItems = thumbnailBarContainer.querySelectorAll('.thumbnail-item');
    thumbnailItems.forEach(item => {
        item.style.cursor = 'pointer';
    });
}

// Apply the exact same filtering logic to mobile thumbnails as desktop
function filterMobileThumbnailImages(selectedVariant) {
    const thumbnailBarContainerMobile = document.getElementById('thumbnail-bar-container-mobile');
    if (!thumbnailBarContainerMobile) return 0;

    const variantSku = (selectedVariant.sku || '').toUpperCase().trim();
    const baseSku = getBaseSku(variantSku);
    const thumbnailItems = thumbnailBarContainerMobile.querySelectorAll('.thumbnail-item-mobile');

    let visibleThumbnailImages = 0;
    let visibleThumbnailGeneralImages = 0;

    // Performance optimization: Use for...of instead of forEach for better performance
    for (let index = 0; index < thumbnailItems.length; index++) {
        const thumbnail = thumbnailItems[index];
        const decision = classifyImageName(thumbnail.dataset.name, variantSku);

        if (decision.show) {
            applyDisplayChange(thumbnail, 'block', 'visible', false);
            thumbnail.style.order = decision.order;

            if (decision.type === 'variant') {
                visibleThumbnailImages++;
            } else if (decision.type === 'general') {
                visibleThumbnailGeneralImages++;
            }
        } else {
            applyDisplayChange(thumbnail, 'none', 'hidden', true);
        }
    }

    const totalVisibleMobileThumbnails = visibleThumbnailImages + visibleThumbnailGeneralImages;

    // Enhanced fallback logic: Trigger if variant image count is too low
    let fallbackMobileThumbnailImages = 0;
    const expectedVariantImages = Math.min(FILTER_CONFIG.minThumbnailVariants, thumbnailItems.length);

    if (visibleThumbnailImages < expectedVariantImages && thumbnailItems.length > 0) {
        for (let index = 0; index < thumbnailItems.length; index++) {
            const thumbnail = thumbnailItems[index];
            const thumbName = (thumbnail.dataset.name || '').toUpperCase();

            // Skip already visible thumbnails
            if (thumbnail.style.display === 'block') continue;

            // Enhanced fallback: Check if thumbnail filename contains the target variant SKU anywhere (case-insensitive)
            const containsSku = thumbName.includes(variantSku.toUpperCase()) ||
                              (baseSku && thumbName.includes(baseSku)) ||
                              thumbName.includes(variantSku.toLowerCase()) ||
                              thumbName.toUpperCase().includes(variantSku.toUpperCase());

            if (containsSku) {
                // Firefox fix: Use explicit function to ensure style changes are applied
                applyDisplayChange(thumbnail, 'block', 'visible', false);
                thumbnail.style.order = isGeneralImageName(thumbName) ? '2' : '1';
                fallbackMobileThumbnailImages++;
            }
        }
    }

    const finalTotalVisibleMobileThumbnails = totalVisibleMobileThumbnails + fallbackMobileThumbnailImages;

    // Hide mobile bar if only one image. Guarded null-check: non-standard product
    // templates (product.bundle.liquid, product.retailers.liquid, etc.) don't
    // render .product-container; an unguarded null-deref here threw TypeError
    // and aborted the rest of the __lagInit_productMain DOMContentLoaded chain,
    // leaving variant picker + dropdown + thumbnail click handlers unregistered.
    const productContainerForMobile = document.querySelector('.product-container');
    if (productContainerForMobile) {
        if (finalTotalVisibleMobileThumbnails <= 1) {
            productContainerForMobile.classList.add('thumbnail-bar-single-image');
        } else {
            productContainerForMobile.classList.remove('thumbnail-bar-single-image');
        }
    }

    // Set visible index for each visible thumbnail in order
    let visibleIndex = 0;
    const visibleThumbnails = Array.from(thumbnailItems)
        .filter(thumb => thumb.style.display !== 'none')
        .sort((a, b) => {
            const orderA = parseInt(a.style.order) || 0;
            const orderB = parseInt(b.style.order) || 0;
            return orderA - orderB;
        });

    visibleThumbnails.forEach((thumbnail, index) => {
        thumbnail.setAttribute('data-visible-index', index);
    });

    // Set first visible thumbnail as active
    setActiveMobileThumbnail(0);

    // Mark filtering as complete - this allows the mobile thumbnail bar to become visible
    const productThumbnailBarMobile = document.getElementById('product-thumbnail-bar-mobile');
    if (productThumbnailBarMobile) {
        productThumbnailBarMobile.classList.add('filter-complete');
    }

    return finalTotalVisibleMobileThumbnails;
}

// Initialize mobile thumbnail bar functionality
function initializeMobileThumbnailClickHandlers() {
    const thumbnailBarContainerMobile = document.getElementById('thumbnail-bar-container-mobile');
    if (!thumbnailBarContainerMobile) return;

    thumbnailBarContainerMobile.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const clickedThumbnail = event.target.closest('.thumbnail-item-mobile');
        if (!clickedThumbnail || clickedThumbnail.style.display === 'none') return;

        const visibleIndex = parseInt(clickedThumbnail.getAttribute('data-visible-index') || '0');

        if (mainSwiper) {
            isManuallyChanging = true;
            try {
                mainSwiper.slideTo(visibleIndex, 0);
                setActiveMobileThumbnail(visibleIndex);
            } catch (error) {
                console.error('Error navigating to slide:', error);
            }
            setTimeout(() => {
                isManuallyChanging = false;
            }, 100);
        }
    });
}

// Set active state for mobile thumbnail
function setActiveMobileThumbnail(activeIndex) {
    const thumbnailBarContainerMobile = document.getElementById('thumbnail-bar-container-mobile');
    if (!thumbnailBarContainerMobile) return;

    const visibleThumbnails = Array.from(thumbnailBarContainerMobile.querySelectorAll('.thumbnail-item-mobile'))
        .filter(item => item.style.display !== 'none')
        .sort((a, b) => {
            const orderA = parseInt(a.style.order) || 0;
            const orderB = parseInt(b.style.order) || 0;
            return orderA - orderB;
        });

    visibleThumbnails.forEach(item => item.classList.remove('active'));

    if (visibleThumbnails[activeIndex]) {
        visibleThumbnails[activeIndex].classList.add('active');
        scrollMobileThumbnailIntoView(visibleThumbnails[activeIndex]);
    }
}

// Horizontal scroll-into-view function for mobile thumbnail bar
function scrollMobileThumbnailIntoView(thumbnail) {
    if (!thumbnail) return;

    const container = document.getElementById('thumbnail-bar-container-mobile');
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const thumbRect = thumbnail.getBoundingClientRect();

    const BUFFER = 8; // Pixel buffer for edge detection

    // Detect left/right scroll necessity
    const isLeft = thumbRect.left < containerRect.left + BUFFER;
    const isRight = thumbRect.right > containerRect.right - BUFFER;

    if (isLeft || isRight) {
        // Center the thumbnail horizontally in the container
        const target = thumbnail.offsetLeft - (container.clientWidth / 2 - thumbnail.clientWidth / 2);
        const clampedTarget = Math.max(0, Math.min(target, container.scrollWidth - container.clientWidth));
        container.scrollTo({ left: clampedTarget, behavior: 'smooth' });
    }
}

// Add swiper slide change event listener
function addSwiperEventListeners() {
    if (!mainSwiper) return;

    mainSwiper.on('slideChange', () => {
        if (!isManuallyChanging) {
            const activeIndex = mainSwiper.activeIndex;
            setActiveThumbnail(activeIndex);
            setActiveMobileThumbnail(activeIndex);
            // Update main image height for thumbnail bar
            setTimeout(updateMainImageHeight, 50);
            // Sync thumbnail bar height on slide change - immediately
            syncThumbnailBarHeight();
            syncMobileThumbnailBarHeight();
            /* filter debug removed */
        }
    });

    // Also listen for slide transition end to ensure sync
    mainSwiper.on('transitionEnd', () => {
        if (!isManuallyChanging) {
            const activeIndex = mainSwiper.activeIndex;
            setActiveThumbnail(activeIndex);
            setActiveMobileThumbnail(activeIndex);
            // Update main image height for thumbnail bar
            setTimeout(updateMainImageHeight, 50);
            // Sync thumbnail bar height on slide change - immediately
            syncThumbnailBarHeight();
            syncMobileThumbnailBarHeight();
            /* filter debug removed */
        }
    });
}

  // Update product details based on the selected variant
  function updateProductDetails(selectedVariant) {
  if (selectedVariant) {
    // Firefox fix: Update URL FIRST before any DOM manipulations that might fail
    // This ensures the variant parameter is in the URL even if other updates fail
    try {
      if (history.replaceState) {
        const currentHash = window.location.hash; // Preserve the current hash
        const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${selectedVariant.id}${currentHash}`;
        window.history.replaceState({ path: newurl }, '', newurl);
      }
    } catch (urlError) {
      // Firefox fix: Fallback for URL update if replaceState fails
      console.warn('Could not update URL with variant:', urlError);
    }

    // Firefox fix: Wrap price updates in try-catch to prevent blocking errors
    try {
      const priceWrapper = document.querySelector('[data-price-wrapper]');
      
      // Firefox fix: Only proceed with price updates if priceWrapper exists
      if (priceWrapper) {
        const productPrice = priceWrapper.querySelector('[data-product-price]');
        const comparePrice = priceWrapper.querySelector('[data-compare-price]');

        // Check if item is on sale
        const isOnSale = selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price;

        // Clear existing price wrapper content
        while (priceWrapper.firstChild) {
          priceWrapper.firstChild.remove();
        }

        if (isOnSale) {
          // Create and append sale price
          const salePrice = document.createElement('span');
          salePrice.classList.add('text-red-600');
          salePrice.setAttribute('data-product-price', '');
          salePrice.setAttribute('itemprop', 'price');
          salePrice.textContent = '$' + (selectedVariant.price / 100).toFixed(2);
          priceWrapper.appendChild(salePrice);

          // Create and append compare price
          const compareElement = document.createElement('span');
          compareElement.classList.add('ml-1', 'text-base', 'text-gray-500', 'line-through');
          compareElement.setAttribute('data-compare-price', '');
          compareElement.textContent = '$' + (selectedVariant.compare_at_price / 100).toFixed(2);
          priceWrapper.appendChild(compareElement);
        } else {
          // Create and append regular price
          const regularPrice = document.createElement('span');
          regularPrice.setAttribute('data-product-price', '');
          regularPrice.setAttribute('itemprop', 'price');
          regularPrice.textContent = '$' + (selectedVariant.price / 100).toFixed(2);
          priceWrapper.appendChild(regularPrice);
        }
      }
    } catch (priceError) {
      console.warn('Could not update price display:', priceError);
    }

    // Update SKU (with null check)
    if (skuElement) {
      skuElement.textContent = selectedVariant.sku;
    }

    // Update add to cart button and quantity selector (with error handling)
    try {
      updateAddToCartState(selectedVariant);
    } catch (cartError) {
      console.warn('Could not update add to cart state:', cartError);
    }

    // Update the selected swatch and dropdown (with error handling)
    try {
      updateSelectedSwatchAndDropdown(selectedVariant.id);
    } catch (swatchError) {
      console.warn('Could not update swatch/dropdown:', swatchError);
    }

    // Update the hidden input for the selected variant (with null checks)
    try {
      if (productForm) {
        const hiddenInput = productForm.querySelector('input[name="id"]');
        if (hiddenInput) {
          hiddenInput.value = selectedVariant.id;
        }
      }
    } catch (formError) {
      console.warn('Could not update hidden form input:', formError);
    }
    }
  }

// Update add to cart button state based on variant availability
function updateAddToCartState(selectedVariant) {
  // Firefox fix: Early return if required elements aren't available
  if (!addToCartButton || !window.productPageData?.product) {
    return;
  }

  const product = window.productPageData.product;
  const buttonTextElement = addToCartButton.querySelector('span');

  // Firefox fix: Check if buttonTextElement exists before proceeding
  if (!buttonTextElement) {
    return;
  }

  // Reset button state
  addToCartButton.disabled = false;
  addToCartButton.style.display = '';
  if (quantitySelector) {
    quantitySelector.style.display = '';
  }

  // Clear any existing retailer buttons
  const existingRetailerButtons = document.getElementById('retailer-redirect-buttons');
  if (existingRetailerButtons) {
    existingRetailerButtons.remove();
  }

  // PRIORITY 1: Check for shade redirection links (retailer exclusive)
  if (selectedVariant.shadeRedirectionLinks && Array.isArray(selectedVariant.shadeRedirectionLinks) && selectedVariant.shadeRedirectionLinks.length > 0) {
    // Hide the add to cart button completely
    addToCartButton.style.display = 'none';
    if (quantitySelector) quantitySelector.style.display = 'none';

    // Create container for retailer buttons
    const retailerButtonContainer = document.createElement('div');
    retailerButtonContainer.id = 'retailer-redirect-buttons';
    retailerButtonContainer.className = 'retailer-redirect-container space-y-3 mt-4';

    // Create a button for each retailer
    selectedVariant.shadeRedirectionLinks.forEach(link => {
      const retailerButton = document.createElement('a');
      retailerButton.href = link.url;
      retailerButton.target = '_blank';
      retailerButton.rel = 'noopener noreferrer';
      retailerButton.className = 'redirect-btn block w-full bg-white border-2 border-black text-black font-semibold py-3 px-6 text-center hover:bg-black hover:text-white transition-colors duration-200';
      retailerButton.textContent = `Buy it at ${link.retailer}`;
      
      retailerButtonContainer.appendChild(retailerButton);
    });

    // Insert the retailer buttons after the add to cart button
    addToCartButton.parentNode.insertBefore(retailerButtonContainer, addToCartButton.nextSibling);
    return;
  }

  // PRIORITY 2: Check variant-specific metafield (disable_buying_from_lag)
  if (selectedVariant.disableBuyingFromLag === true) {
    addToCartButton.disabled = true;
    buttonTextElement.textContent = 'Coming Soon';
    if (quantitySelector) quantitySelector.style.display = 'none';
  } 
  // PRIORITY 3: Check vendor-based restrictions
  else if (product.vendor === 'NotForSale') {
    if (product.tags && product.tags.includes('sold-out')) {
      addToCartButton.disabled = true;
      buttonTextElement.textContent = 'Sold Out';
      if (quantitySelector) quantitySelector.style.display = 'none';
    } else {
      addToCartButton.disabled = true;
      buttonTextElement.textContent = 'Available In Stores Only';
      if (quantitySelector) quantitySelector.style.display = 'none';
    }
  } 
  // PRIORITY 4: Check variant availability
  else if (!selectedVariant.available) {
    addToCartButton.disabled = true;
    buttonTextElement.textContent = 'Out of Stock';
  } 
  // PRIORITY 5: Check product-level coming soon tag
  else if (product.tags && product.tags.includes('coming soon')) {
    addToCartButton.disabled = true;
    buttonTextElement.textContent = 'Coming Soon';
    if (quantitySelector) quantitySelector.style.display = 'none';
  } 
  // DEFAULT: Available for purchase
  else {
    buttonTextElement.textContent = 'Add to Bag';
  }
}

  // Update the selected swatch and dropdown display
  function updateSelectedSwatchAndDropdown(variantId) {
    // Remove 'selected' class from all swatches
    document.querySelectorAll('.swatch-icon button').forEach(swatch => {
      swatch.classList.remove('selected');
      swatch.setAttribute('aria-pressed', 'false');
    });

    // Add 'selected' class to the correct swatch
    const selectedSwatch = document.querySelector(`.swatch-icon[data-variant-id="${variantId}"] button`);
    if (selectedSwatch) {
      selectedSwatch.classList.add('selected');
      selectedSwatch.setAttribute('aria-pressed', 'true');
    }

    // Update dropdown display
    const selectedVariantTitle = document.getElementById('selected-variant-title');
    const variantItem = document.querySelector(`.variant-dropdown-item[data-variant-id="${variantId}"]`);
    if (variantItem && selectedVariantTitle) {
      selectedVariantTitle.textContent = variantItem.textContent;
    }

    // Update swatch in dropdown
    const selectedSwatchInDropdown = document.getElementById('selected-swatch');
    if (selectedSwatchInDropdown && variantItem) {
      // Clear both vars first. .swatch-label paints background-color (--swatch-color)
      // AND background-image (--swatch-bkg), with the image on top. Without clearing,
      // switching from an image-based shade to a hex-color shade (or vice versa) leaves
      // the previous shade's value set, so the stale swatch bleeds through until refresh.
      selectedSwatchInDropdown.style.removeProperty('--swatch-color');
      selectedSwatchInDropdown.style.removeProperty('--swatch-bkg');
      if (variantItem.dataset.hexCode) {
        selectedSwatchInDropdown.style.setProperty('--swatch-color', variantItem.dataset.hexCode);
      }
      if (variantItem.dataset.hexImg) {
        selectedSwatchInDropdown.style.setProperty('--swatch-bkg', `url('${variantItem.dataset.hexImg}')`);
      }
    }
  }

  // Handle variant selection
  function updateVariantSelection(selectedVariantId) {
    const selectedVariant = window.productPageData.productVariants.find(variant => variant.id == selectedVariantId);
    if (selectedVariant) {
      updateProductDetails(selectedVariant);
      updateSliderImages(selectedVariant);

      // Sync thumbnail bar height after variant change - immediately
      syncThumbnailBarHeight();
      setTimeout(syncThumbnailBarHeight, 50); // Quick follow-up

      // Dispatch event for short description update
      const variantChangeEvent = new CustomEvent('variant:change', {
        detail: { variant: selectedVariant }
      });
      document.dispatchEvent(variantChangeEvent);
      
      // Dispatch additional event for variant selection updates
      const variantSelectionEvent = new CustomEvent('variantSelectionUpdate', {
        detail: { variantId: selectedVariant.id, variant: selectedVariant }
      });
      document.dispatchEvent(variantSelectionEvent);
    } else {
      // Fallback to first variant if selected variant is not found
      const fallbackVariant = window.productPageData.productVariants[0];
      
      if (fallbackVariant) {
        updateProductDetails(fallbackVariant);
        updateSliderImages(fallbackVariant);

        // Sync thumbnail bar height after fallback variant change - immediately
        syncThumbnailBarHeight();
        setTimeout(syncThumbnailBarHeight, 50); // Quick follow-up

        // Dispatch event for short description update
        const variantChangeEvent = new CustomEvent('variant:change', {
          detail: { variant: fallbackVariant }
        });
        document.dispatchEvent(variantChangeEvent);
        
        // Dispatch additional event for variant selection updates
        const variantSelectionEvent = new CustomEvent('variantSelectionUpdate', {
          detail: { variantId: fallbackVariant.id, variant: fallbackVariant }
        });
        document.dispatchEvent(variantSelectionEvent);
      }
    }
  }

  // Initialize the product with the correct initial variant.
  // productPageData is set inline in templates/product.liquid BEFORE this
  // script runs, so it is always present at DOMContentLoaded — no retry
  // loop needed.
  function initializeProduct() {
    const productVariants = (window.productPageData && window.productPageData.productVariants) || [];
    if (productVariants.length === 0) return;

    let initialVariant;

    // Check if there's a variant parameter in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariantId = urlParams.get('variant');

    if (urlVariantId) {
      // Try to find the variant specified in the URL
      const urlVariant = productVariants.find(variant => variant.id == urlVariantId);
      if (urlVariant) {
        initialVariant = urlVariant;
      }
    }

    // Authoritative server-side pick from Liquid's product.selected_or_first_available_variant.
    // Use this when there's no URL variant (or the URL variant doesn't resolve), so JS picks
    // the exact variant Shopify rendered the page with — image filenames in the DOM correspond
    // to this variant's SKU. Falling back to a JS-side heuristic
    // (productVariants.find(v => v.available)) can pick a different variant when availability
    // ordering differs between Liquid and the JS-serialized array, and the SKU mismatch then
    // filters every slide out via classifyImageName, leaving the slider + thumbnail bar empty.
    if (!initialVariant) {
      const liquidVariantId = window.productPageData.selectedOrFirstAvailableVariantId;
      if (liquidVariantId) {
        const liquidVariant = productVariants.find(variant => variant.id == liquidVariantId);
        if (liquidVariant) {
          initialVariant = liquidVariant;
        }
      }
    }

    // If neither URL nor Liquid-injected ID resolved, fall back to original heuristic.
    if (!initialVariant) {
      const availableVariant = productVariants.find(variant => variant.available);
      if (availableVariant) {
        initialVariant = availableVariant;
      } else {
        initialVariant = productVariants[0];
      }
    }

    // Firefox fix: Check if we have a valid variant before proceeding
    if (!initialVariant) {
      console.warn('Could not determine initial variant');
      return;
    }

    // Update the hidden input with the selected variant ID (with null checks)
    try {
      if (productForm) {
        const hiddenInput = productForm.querySelector('input[name="id"]');
        if (hiddenInput) {
          hiddenInput.value = initialVariant.id;
        }
      }
    } catch (formError) {
      console.warn('Could not update hidden form input during init:', formError);
    }

    // Update product details and slider images
    try {
      updateProductDetails(initialVariant);
    } catch (detailsError) {
      console.warn('Error updating product details:', detailsError);
    }

    try {
      updateSliderImages(initialVariant);
    } catch (sliderError) {
      console.warn('Error updating slider images:', sliderError);
    }
    
    // Dispatch variant events for any external listeners (short description, etc.)
    try {
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: initialVariant } }));
      document.dispatchEvent(new CustomEvent('variantSelectionUpdate', { detail: { variantId: initialVariant.id, variant: initialVariant } }));
    } catch (eventError) {
      // Older browsers may lack CustomEvent; silently degrade.
    }
  }

  // Initialize everything - product first, then swiper.
  // Swiper is loaded with `defer` from head_scripts.liquid in document order
  // BEFORE product.js, so window.Swiper is defined here. The retry below is
  // a single deferred check for the rare case the CDN script is slow.
  initializeProduct();
  function ensureSwiperInit(attempt) {
    if (window.Swiper) {
      try { initializeSwiper(); } catch (e) {
        if (window.console && console.warn) console.warn('[LAG-PDP] swiper init threw', e);
      }
      return;
    }
    if (attempt >= 50) return; // 50 × 100ms = 5s budget, then give up
    setTimeout(() => ensureSwiperInit(attempt + 1), 100);
  }
  ensureSwiperInit(0);
  
  // Ensure filtering is applied after everything is loaded
  window.addEventListener('load', () => {
    const currentVariantId = document.querySelector('input[name="id"]')?.value;
    if (currentVariantId && window.productPageData?.productVariants) {
      const currentVariant = window.productPageData.productVariants.find(v => v.id == currentVariantId);
      if (currentVariant) {
        updateSliderImages(currentVariant);
      }
    }
  });

  // Function to setup variant event listeners
  function setupVariantEventListeners() {
    // Event listeners for swatch icons
    const variantSelector = document.getElementById('swatch-icons');
    if (variantSelector) {
      variantSelector.addEventListener('click', (event) => {
        const swatchIcon = event.target.closest('.swatch-icon');
        if (swatchIcon) {
          const variantId = swatchIcon.dataset.variantId;
          if (variantId) {
            updateVariantSelection(variantId);
          }
        }
      });
    }
    
    // Custom dropdown functionality
    const customDropdown = document.querySelector('.custom-dropdown');
    const dropdownMenu = document.querySelector('.variant-dropdown-menu');
    
    if (customDropdown && dropdownMenu) {
      customDropdown.addEventListener('click', () => {
        dropdownMenu.classList.toggle('show');
      });

      const dropdownItems = document.querySelectorAll('.variant-dropdown-item');
      dropdownItems.forEach((item) => {
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const variantId = item.dataset.variantId;
          updateVariantSelection(variantId);
          dropdownMenu.classList.remove('show');
        });
      });
    }
  }
  
  
  // Setup event listeners
  setupVariantEventListeners();

  // Global delegated click handler to ensure variant switching always works
  document.addEventListener('click', (event) => {
    const variantEl = event.target.closest('.swatch-icon, .variant-dropdown-item');
    if (!variantEl) return;
    const variantId = variantEl.getAttribute('data-variant-id');
    if (variantId) {
      updateVariantSelection(variantId);
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', (event) => {
    const customDropdown = document.querySelector('.custom-dropdown');
    const dropdownMenu = document.querySelector('.variant-dropdown-menu');
    if (customDropdown && dropdownMenu && !customDropdown.contains(event.target)) {
      dropdownMenu.classList.remove('show');
    }
  });

  // Quantity selector functionality
  const decrementBtn = document.querySelector('.decrement-qty');
  const incrementBtn = document.querySelector('.increment-qty');

  function updateQuantityInput() {
    // Ensure the quantity input in the form is updated
    const formQuantityInput = productForm.querySelector('input[name="quantity"]');
    if (formQuantityInput) {
      formQuantityInput.value = quantityInput.value;
    } else {
      // If the quantity input doesn't exist in the form, create it
      const newQuantityInput = document.createElement('input');
      newQuantityInput.type = 'hidden';
      newQuantityInput.name = 'quantity';
      newQuantityInput.value = quantityInput.value;
      productForm.appendChild(newQuantityInput);
    }
   
  }

  if (incrementBtn && quantityInput) {
    incrementBtn.addEventListener('click', (event) => {
      event.preventDefault();
      quantityInput.value = parseInt(quantityInput.value) + 1;
      updateQuantityInput();
    });
  }

  if (decrementBtn && quantityInput) {
    decrementBtn.addEventListener('click', (event) => {
      event.preventDefault();
      if (parseInt(quantityInput.value) > 1) {
        quantityInput.value = parseInt(quantityInput.value) - 1;
        updateQuantityInput();
      }
    });
  }

  // Handle form submission
  if (productForm) {
    productForm.addEventListener('submit', (event) => {
      // Ensure the quantity is correctly set before submission
      updateQuantityInput();

      // Allow the form to submit normally
    });
  }

    try { (window.__lagTrace = window.__lagTrace || []).push({ at: 'master-dcl-complete', t: Date.now() }); } catch (_) {}
  } catch (err) {
    if (window.console && console.error) console.error('[LAG-PDP-DCL-MASTER]', err);
    try { (window.__lagTrace = window.__lagTrace || []).push({ at: 'master-dcl-error', t: Date.now(), msg: String(err && err.message || err) }); } catch (_) {}
  }
});
lagOnReady(function() {
  try { (window.__lagTrace = window.__lagTrace || []).push({ at: 'variant-dropdown-observer-dcl-fire', t: Date.now() }); } catch (_) {}
  try {
    const dropdownMenu = document.querySelector('.variant-dropdown-menu');
    const customVariantDropdown = document.querySelector('.custom-variant-dropdown');
    if (!dropdownMenu || !customVariantDropdown) return;

    const updateClass = () => {
      if (dropdownMenu.classList.contains('show')) {
        customVariantDropdown.classList.add('active');
      } else {
        customVariantDropdown.classList.remove('active');
      }
    };
    updateClass();

    const observer = new MutationObserver(() => updateClass());
    observer.observe(dropdownMenu, { attributes: true, attributeFilter: ['class'] });
  } catch (err) {
    if (window.console && console.error) console.error('[LAG-PDP-DCL-DROPDOWN]', err);
  }
});

lagOnReady(function() {
  try { (window.__lagTrace = window.__lagTrace || []).push({ at: 'sticky-dcl-fire', t: Date.now() }); } catch (_) {}
  try {
    const header = document.getElementById('site-header');
    const productImage = document.getElementById('product-main-image');
    if (!header || !productImage) return;
    const mdBreakpoint = 768;
    const lgBreakpoint = 1024;

    function updateStickyPosition() {
      const headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      document.documentElement.style.setProperty('--sticky-top-position', 'calc(' + headerHeight + 'px + 1rem)');
      if (window.innerWidth >= mdBreakpoint) {
        productImage.style.position = 'sticky';
        productImage.style.top = window.innerWidth >= lgBreakpoint ? '2.5rem' : '7.5rem';
      } else {
        productImage.style.position = '';
        productImage.style.top = '';
      }
    }

    let stickyTimeout;
    const debouncedUpdate = () => {
      clearTimeout(stickyTimeout);
      stickyTimeout = setTimeout(updateStickyPosition, 250);
    };

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(debouncedUpdate);
      ro.observe(header);
    }
    updateStickyPosition();
    window.addEventListener('resize', debouncedUpdate);
  } catch (err) {
    if (window.console && console.error) console.error('[LAG-PDP-DCL-STICKY]', err);
  }
});

  // Unified mouse drag scroll functionality for all thumbnail bars
  function createDragScrollHandler(container, isDesktopContainer = true) {
    if (!container) return;

    let isDragging = false;
    let startX = 0, startY = 0;
    let scrollLeft = 0, scrollTop = 0;
    let dragThreshold = 5; 
    let clickStartPos = null;
    let lastMoveTime = 0;
    let velocityX = 0, velocityY = 0;
    let lastX = 0, lastY = 0;
    let hasDraggedBeyondThreshold = false; 

    container.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      clickStartPos = { x: e.clientX, y: e.clientY };
      isDragging = true;
      hasDraggedBeyondThreshold = false;
      startX = e.pageX;
      startY = e.pageY;
      lastX = e.pageX;
      lastY = e.pageY;
      scrollLeft = container.scrollLeft;
      scrollTop = container.scrollTop;
      lastMoveTime = Date.now();
      velocityX = 0;
      velocityY = 0;

      container.style.userSelect = 'none';

      if (e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging || !clickStartPos) return;

      // Self-healing watchdog: if no mouse button is currently held, the drag
      // isn't real. Without this guard, a mouseup that gets stopPropagation'd
      // by a child handler (or fires outside the document) leaves isDragging
      // stuck true; every subsequent mousemove then calls e.preventDefault()
      // and kills click hit-testing on swatches, dropdown, and main slider —
      // user has to refresh to recover. Triggers reliably on variants with
      // many thumbs because the bar becomes scrollable and the drag handler
      // engages on every interaction near the bar.
      if (e.buttons === 0) {
        isDragging = false;
        hasDraggedBeyondThreshold = false;
        clickStartPos = null;
        container.style.userSelect = '';
        return;
      }

      const deltaX = Math.abs(e.clientX - clickStartPos.x);
      const deltaY = Math.abs(e.clientY - clickStartPos.y);

      // Check if we've moved beyond the threshold
      if (!hasDraggedBeyondThreshold && (deltaX > dragThreshold || deltaY > dragThreshold)) {
        hasDraggedBeyondThreshold = true;
      }

      // Only start scrolling if we've moved beyond the threshold
      if (hasDraggedBeyondThreshold) {
        e.preventDefault();

        // Determine layout type by checking container's actual CSS flex direction
        const containerFlexDirection = window.getComputedStyle(container).flexDirection;
        const isHorizontalLayout = containerFlexDirection === 'row';

        // Calculate smooth scrolling with momentum
        const currentTime = Date.now();
        const timeDelta = currentTime - lastMoveTime;
        const currentX = e.pageX;
        const currentY = e.pageY;
        const movementX = currentX - lastX;
        const movementY = currentY - lastY;

        // Calculate velocity for momentum
        if (timeDelta > 0) {
          velocityX = movementX / timeDelta;
          velocityY = movementY / timeDelta;
        }

        if (isHorizontalLayout) {
          // Horizontal scrolling for bottom layout
          const currentDeltaX = currentX - startX;
          const targetScrollLeft = scrollLeft - currentDeltaX;
          const clampedScrollLeft = Math.max(0, Math.min(targetScrollLeft, container.scrollWidth - container.clientWidth));
          container.scrollLeft = clampedScrollLeft;
        } else {
          // Vertical scrolling for left side layout
          const currentDeltaY = currentY - startY;
          const targetScrollTop = scrollTop - currentDeltaY;
          const clampedScrollTop = Math.max(0, Math.min(targetScrollTop, container.scrollHeight - container.clientHeight));
          container.scrollTop = clampedScrollTop;
        }

        // Update last position and time
        lastX = currentX;
        lastY = currentY;
        lastMoveTime = currentTime;
      }
    });

    document.addEventListener('mouseup', (e) => {
      if (!isDragging) return;

      const hasMoved = hasDraggedBeyondThreshold;

      isDragging = false;
      hasDraggedBeyondThreshold = false;
      clickStartPos = null;
      container.style.userSelect = '';

      // Determine layout type by checking container's actual CSS flex direction
      const containerFlexDirection = window.getComputedStyle(container).flexDirection;
      const isHorizontalLayout = containerFlexDirection === 'row';

      // Add momentum scrolling after release
      if (hasMoved && (Math.abs(velocityX) > 0.1 || Math.abs(velocityY) > 0.1)) {
        const momentumScroll = () => {
          if (isHorizontalLayout) {
            // Horizontal momentum
            const currentScrollLeft = container.scrollLeft;
            const momentum = velocityX * 30; // Scale velocity for momentum
            const targetScroll = currentScrollLeft - momentum;
            const clampedTarget = Math.max(0, Math.min(targetScroll, container.scrollWidth - container.clientWidth));

            // Smooth deceleration
            const scrollDiff = clampedTarget - currentScrollLeft;
            const newScrollLeft = currentScrollLeft + (scrollDiff * 0.1);

            container.scrollLeft = newScrollLeft;

            // Reduce velocity
            velocityX *= 0.85;

            // Continue momentum if velocity is significant
            if (Math.abs(velocityX) > 0.01 && Math.abs(scrollDiff) > 0.5) {
              requestAnimationFrame(momentumScroll);
            }
          } else {
            // Vertical momentum
            const currentScrollTop = container.scrollTop;
            const momentum = velocityY * 30; // Scale velocity for momentum
            const targetScroll = currentScrollTop - momentum;
            const clampedTarget = Math.max(0, Math.min(targetScroll, container.scrollHeight - container.clientHeight));

            // Smooth deceleration
            const scrollDiff = clampedTarget - currentScrollTop;
            const newScrollTop = currentScrollTop + (scrollDiff * 0.1);

            container.scrollTop = newScrollTop;

            // Reduce velocity
            velocityY *= 0.85;

            // Continue momentum if velocity is significant
            if (Math.abs(velocityY) > 0.01 && Math.abs(scrollDiff) > 0.5) {
              requestAnimationFrame(momentumScroll);
            }
          }
        };

        requestAnimationFrame(momentumScroll);
      }

      // If we dragged significantly, prevent click events on thumbnail items
      if (hasMoved) {
        e.preventDefault();
        e.stopImmediatePropagation();

        // Prevent clicks on thumbnail items for a short time after drag
        const thumbnailSelector = isDesktopContainer ? '.thumbnail-item' : '.thumbnail-item-mobile';
        const thumbnailItems = container.querySelectorAll(thumbnailSelector);
        thumbnailItems.forEach(item => {
          item.style.pointerEvents = 'none';
        });

        // Re-enable clicks after momentum scrolling finishes
        setTimeout(() => {
          thumbnailItems.forEach(item => {
            item.style.pointerEvents = '';
          });
        }, 200); // Slightly longer delay to ensure momentum completes
      }

    });

    // Prevent default drag behavior on images
    container.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });
  }

  // Enhanced mouse drag scroll functionality for thumbnail slider
  function initializeThumbnailDragScroll() {
    // Initialize drag scroll for desktop/tablet thumbnail bar
    const desktopContainer = document.getElementById('thumbnail-bar-container') ||
                             document.querySelector('.thumbnail-bar-container');
    if (desktopContainer) {
      createDragScrollHandler(desktopContainer, true);
    }

    // Initialize drag scroll for mobile thumbnail bar
    const mobileContainer = document.getElementById('thumbnail-bar-container-mobile');
    if (mobileContainer) {
      createDragScrollHandler(mobileContainer, false);
    }
  }
